// Mirrors DISPOSAL_ALLOWED_ROLES in tmg-api-functions/function_app.py:6802.
// Keep in sync — both the nav and the route guard for /supplier/disposal/*
// read from here.
export const DISPOSAL_ROLES = [
  'ADMIN',
  'SUPPLIER_MANAGER',
  'SUPPLIER_USER',
  'FIELD_REP',
  'PROJECT_LEAD',
  'DISPOSAL_LEAD',
];

export function hasDisposalAccess(role) {
  return DISPOSAL_ROLES.includes(role);
}
